import {
  CreateTask,
  PatchTask,
  Task,
} from "@coworker/apprestructured/src/task-management/types/Task";
import { TASKS_SERVICE_URL } from "@coworker/app/src/hooks/API/tasks.service.helper";
import {
  createAuthorizationHeader,
  toJson,
} from "@coworker/apprestructured/src/task-management/services/fetchHelper";
import { Log } from "../types/Log";
import { Comment } from "../types/Comment";
import { SignedUpload } from "@coworker/apprestructured/src/task-management/types/Upload";

const BASE_URL = `${TASKS_SERVICE_URL}/tasks-v2`;

export async function createTask(createTask: CreateTask) {
  return toJson<Task>(
    await fetch(BASE_URL, {
      method: "POST",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(createTask),
    })
  );
}

export async function getTasks(ids: string[]) {
  return toJson<Task[]>(
    await fetch(BASE_URL + `/${ids.join(",")}`, {
      method: "GET",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
    })
  );
}

export async function getTask(id: string) {
  const tasks = await getTasks([id]);
  return tasks[0];
}

export async function updateTask(id: string, patchTask: PatchTask) {
  return toJson<Task>(
    await fetch(BASE_URL + `/${id}`, {
      method: "PATCH",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(patchTask),
    })
  );
}

export async function getTaskLogs(id: string) {
  return toJson<Log[]>(
    await fetch(BASE_URL + `/${id}/logs`, {
      method: "GET",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
    })
  );
}

export async function getTaskComments(id: string) {
  return toJson<Comment[]>(
    await fetch(BASE_URL + `/${id}/comments`, {
      method: "GET",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
    })
  );
}

export async function getTasksImages(taskId: string) {
  return toJson<SignedUpload[]>(
    await fetch(BASE_URL + `/${taskId}/images`, {
      method: "GET",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
    })
  );
}
